import { render, staticRenderFns } from "./halfPrice.vue?vue&type=template&id=63363eb0&"
import script from "./halfPrice.vue?vue&type=script&lang=js&"
export * from "./halfPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports